import styled from 'styled-components';

export const UnidaysIntegrationContainer = styled.div`
  margin: 10px auto;
  max-width: 1500px;
  width: 100%;

  unidays-access {
    display: flex;
  }
`;
